import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  Stack,
  TextField,
  Box,
  IconButton,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const JobPopupFlow = ({ job, onClose }: any) => {
  const [step, setStep] = useState<"details" | "apply">("details");

  if (!job) return null;

  const handleCloseAll = () => {
    setStep("details");
    onClose();
  };

  return (
    <Dialog
      open={!!job}
      onClose={handleCloseAll}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: "20px",
          overflow: "hidden",
        },
      }}
    >
      <DialogContent sx={{ p: 0 }}>

        {/* HEADER */}
        <Box
          sx={{
            p: 3,
            background:
              "linear-gradient(90deg,#0f63a5,#42a5f5)",
            color: "#fff",
            position: "relative",
          }}
        >
          <Typography fontSize="1.2rem" fontWeight={600}>
            {step === "details" ? job.title : "Apply for Role"}
          </Typography>

          <IconButton
            onClick={handleCloseAll}
            sx={{
              position: "absolute",
              right: 10,
              top: 10,
              color: "#fff",
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        {/* BODY */}
        <Box sx={{ p: 3 }}>

          {step === "details" && (
            <>
              {/* INFO ROW */}
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  flexWrap: "wrap",
                  mb: 2,
                }}
              >
                <Stack direction="row" spacing={1} alignItems="center">
                  <WorkOutlineIcon fontSize="small" />
                  <Typography>{job.experience}</Typography>
                </Stack>

                <Stack direction="row" spacing={1} alignItems="center">
                  <LocationOnIcon fontSize="small" />
                  <Typography>{job.location}</Typography>
                </Stack>
              </Box>

              {/* DESCRIPTION */}
              <Typography sx={{ mb: 2 }}>
                {job.desc}
              </Typography>

              <Divider sx={{ my: 2 }} />

              {/* RESPONSIBILITIES */}
              <Typography fontWeight={600} mb={1}>
                Responsibilities
              </Typography>

              {job.responsibilities.map((r: string, i: number) => (
                <Typography key={i} sx={{ mb: 0.5 }}>
                  • {r}
                </Typography>
              ))}

              <Button
                fullWidth
                variant="contained"
                sx={{
                  mt: 3,
                  borderRadius: "30px",
                  background:
                    "linear-gradient(90deg,#0f63a5,#42a5f5)",
                }}
                onClick={() => setStep("apply")}
              >
                Apply Now
              </Button>
            </>
          )}

          {/* 🔥 APPLY FORM */}
          {step === "apply" && (
            <Stack spacing={2}>
              <TextField label="Full Name" fullWidth />
              <TextField label="Email" fullWidth />
              <TextField label="Phone Number" fullWidth />

              {/* RESUME */}
              <Box>
                <Typography mb={1}>Upload Resume</Typography>

                <Button
                  fullWidth
                  variant="outlined"
                  component="label"
                  sx={{
                    borderStyle: "dashed",
                    py: 1.5,
                  }}
                >
                  Upload Resume (PDF/DOC)
                  <input
                    hidden
                    type="file"
                    accept=".pdf,.doc,.docx"
                  />
                </Button>
              </Box>

              <Button
                variant="contained"
                sx={{
                  borderRadius: "30px",
                  background:
                    "linear-gradient(90deg,#0f63a5,#42a5f5)",
                }}
              >
                Submit Application
              </Button>
            </Stack>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default JobPopupFlow;